import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-469c06c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "banner"
}
const _hoisted_2 = { class: "install-banner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-banner-content" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, [
    /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Installa l'applicazione"),
    /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Aggiungi l'app alla schermata Home per accedere più facilmente.")
  ])
], -1))
const _hoisted_4 = {
  key: 0,
  class: "install-banner-instructions"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-banner-step" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "install-banner-step-text" }, "Segui i passaggi:")
], -1))
const _hoisted_6 = { class: "install-banner-step" }
const _hoisted_7 = { class: "install-banner-step-number" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-banner-step-text" }, "Clicca sul pulsante \"Condividi\".", -1))
const _hoisted_9 = { class: "install-banner-step" }
const _hoisted_10 = { class: "install-banner-step-number" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-banner-step-text" }, "Scorri l'elenco delle opzioni fino a trovare \"Aggiungi a schermata Home\".", -1))
const _hoisted_12 = { class: "install-banner-step" }
const _hoisted_13 = { class: "install-banner-step-number" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-banner-step-text" }, "Clicca su \"Aggiungi a schermata Home\".", -1))
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_ctx.showInstallBanner || _ctx.deferredPrompt)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissInstallBanner && _ctx.dismissInstallBanner(...args)))
          }, [
            _createVNode(_component_ion_icon, {
              slot: "end",
              icon: _ctx.close,
              size: "large"
            }, null, 8, ["icon"])
          ]),
          _createVNode(_component_ion_img, {
            class: "img",
            src: _ctx.logoImage
          }, null, 8, ["src"]),
          _hoisted_3,
          (_ctx.isSafariMobileiOS)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ion_img, {
                      class: "icon",
                      src: _ctx.share
                    }, null, 8, ["src"])
                  ]),
                  _hoisted_8
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ion_img, {
                      class: "icon",
                      src: _ctx.launch
                    }, null, 8, ["src"])
                  ]),
                  _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_ion_img, {
                      class: "icon",
                      src: _ctx.add
                    }, null, 8, ["src"])
                  ]),
                  _hoisted_14
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_ion_button, {
                  onClick: _ctx.install,
                  expand: "block"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Installa")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}